<template>
    <div class="vc-completed">
        <div class="vc-completed__welcome">
            <img class="vc-completed__welcome-img" src="/images/common/register_completed_01.jpg">
            <p class="vc-completed__welcome-text mb-0">{{ $locale.appName }}オンライン医療相談サービスへようこそ！<br>ご登録のメールアドレスに確認メールを送信しました。</p>
        </div>

        <section class="vc-completed__box">
            <div class="vc-completed__app">
                <div class="d-flex justify-content-center align-items-center">
                    <img class="vc-completed__app-img" src="/images/common/appicon.png">
                    <div>
                        <h3 class="vc-completed__box-heading">スマホで、どこからでも相談できます。</h3>
                        <p class="vc-completed__box-text">ぜひアプリ版をダウンロードしてご利用ください。</p>
                    </div>
                </div>
            </div>
            <div class="vc-completed__dl">
                <div class="d-flex justify-content-center align-items-center">
                    <template v-if="$locale.type === 'consul'">
                        <a href="https://apps.apple.com/jp/app/id1625616546" target="_blank">
                            <img class="vc-completed__dl-img01" src="/images/common/btn-dl-apple.png">
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=jp.realll.consul.yokumiru" target="_blank">
                            <img class="vc-completed__dl-img02" src="/images/common/btn-dl-googleplay.png">
                        </a>
                    </template>
                    <template v-else>
                        <a href="https://apps.apple.com/jp/app/id1519400662" target="_blank">
                            <img class="vc-completed__dl-img01" src="/images/common/btn-dl-apple.png">
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=jp.realll.yokumiru" target="_blank">
                            <img class="vc-completed__dl-img02" src="/images/common/btn-dl-googleplay.png">
                        </a>
                    </template>
                </div>
                <p class="vc-completed__dl-text">※&nbsp;相談予約にはクレジットカードまたはデビットカードのご登録が必要です。</p>
            </div>
        </section>

        <a class="vc-link-black" href="https://yokumiru.jp/yokumiru-support" target="_blank">
            <section class="vc-completed__box">
                <div class="vc-completed__manual">
                    <div class="d-flex justify-content-center align-items-center">
                        <img class="vc-completed__manual-img" src="/images/common/icon-book.png">
                        <div class="vc-completed__manual-text">
                            <h3 class="vc-completed__box-heading">{{ $locale.appName }}操作マニュアル</h3>
                            <p class="vc-completed__box-text">サービスのご利用方法が確認できます。</p>
                        </div>
                    </div>
                </div>
            </section>
        </a>

        <div class="vc-completed__btn d-flex justify-content-center">
            <a
                class="btn btn-link btn-yokumiru-orange vc-link-white"
                href="/login">
                ログイン画面へ進む&nbsp;（Web版）
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {}
        },
    }
</script>

<style lang="scss" scoped>
.vc-completed {
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
    max-width: 860px;
    padding: 0 30px;
    margin: 0 auto;
    box-sizing: border-box;

    @media screen and (max-width:767px) {
        padding: 0 15px;
    }

    .vc-completed__welcome-img {
        max-width: 100%;
        margin: 30px 0 40px;

        @media screen and (max-width:767px) {
            margin: 15px 0 20px;
        }
    }

    .vc-completed__welcome {
        margin-bottom: 40px;

        @media screen and (max-width:767px) {
            margin-bottom: 23px;
        }

        .vc-completed__welcome-text {
            font-size: 16px;
            text-align: center;

            @media screen and (max-width:767px) {
                font-size: 13px;
            }
        }
    }

    .vc-completed__box {
        width: 100%;
        margin-bottom: 25px;
        padding: 30px;
        background: #fff;
        border: 1px solid #7f7f7f;
        box-sizing: border-box;
        border-radius: 6px;

        @media screen and (max-width:767px) {
            margin-bottom: 20px;
            padding: 15px;
        }

        .vc-completed__box-heading {
            margin-bottom: 4px;
            font-size: 24px;
            font-weight: bold;
            font-feature-settings: 'palt';

            @media screen and (max-width:767px) {
                font-size: 16px;
            }
        }

        .vc-completed__box-text {
            margin-bottom: 0;
            font-size: 16px;
            font-feature-settings: 'palt';

            @media screen and (max-width:767px) {
                font-size: 12px;
            }
        }
    }

    .vc-completed__app {
        .vc-completed__app-img {
            width: 90px;
            height: 90px;
            margin-right: 20px;

            @media screen and (max-width:767px) {
                width: 46px;
                height: 46px;
                margin-right: 10px;
            }
        }
    }

    .vc-completed__dl {
        margin-top: 32px;

        @media screen and (max-width:767px) {
            margin-top: 20px;
        }

        a {
            text-decoration: none;
        }

        .vc-completed__dl-img01,
        .vc-completed__dl-img02 {
            width: 180px;
            margin: 0 11px;

            @media screen and (max-width:767px) {
                width: 120px;
                margin: 0 6px;
            }
        }

        .vc-completed__dl-text {
            margin: 18px 0 0 0;
            font-size: 14px;
            text-align: center;

            @media screen and (max-width:767px) {
                margin-top: 10px;
                font-size: 12px;
            }
        }
    }

    .vc-completed__manual {
        .vc-completed__manual-img {
            width: 64px;
            height: 78px;
            margin-right: 20px;

            @media screen and (max-width:767px) {
                width: 38px;
                height: 46px;
                margin-right: 10px;
            }
        }

        .vc-completed__manual-text {
            min-width: 240px;
        }
    }

    .vc-completed__btn {
        margin: 55px 0;

        @media screen and (max-width:767px) {
            margin: 40px 0;
        }

        a.btn {
            padding: 12px 20px;
            font-feature-settings: 'palt';

            @media screen and (max-width:767px) {
                padding: 8px 15px;
            }
        }
    }

    .vc-link-black {
        color: #212529;
    }

    .vc-link-white {
        color: #fff;
    }
}
</style>
